import { render, staticRenderFns } from "./CancelService.vue?vue&type=template&id=05965042&scoped=true&"
import script from "./CancelService.vue?vue&type=script&lang=js&"
export * from "./CancelService.vue?vue&type=script&lang=js&"
import style0 from "./CancelService.vue?vue&type=style&index=0&id=05965042&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05965042",
  null
  
)

export default component.exports